const formNodeStrings = {
	patientInfo: 'Patient Information',
	dateTime: 'Date & Time',
	additionalInfo: 'Additional Patient Information',
	guarantorInfo: 'Guarantor Information',
	apptReview: 'Appointment Review',
	confirmation: 'Confirmation',
};

const formNodeStringsES = {
	patientInfo: 'Información del paciente',
	dateTime: 'Fecha y hora',
	additionalInfo: 'Información adicional del paciente',
	guarantorInfo: 'Información del garante',
	apptReview: 'Revisión de cita',
	confirmation: 'Confirmación',
};

const constantStrings = {
	formNodeStrings,
	formNodeStringsES,
};
export default constantStrings;
